namespace GeniuzPOS.InventoryReport {
    export interface IcReport04_VRow {
        Id?: string;
        Grouptype?: string;
        GroupCode?: string;
        GroupName?: string;
        QtyOnHand?: number;
        StockCostValue?: number;
    }

    export namespace IcReport04_VRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Grouptype';
        export const localTextPrefix = 'InventoryReport.IcReport04_V';
        export const deletePermission = '2Inventory:รายงาน:มูลค่า:View';
        export const insertPermission = '2Inventory:รายงาน:มูลค่า:View';
        export const readPermission = '2Inventory:รายงาน:มูลค่า:View';
        export const updatePermission = '2Inventory:รายงาน:มูลค่า:View';

        export declare const enum Fields {
            Id = "Id",
            Grouptype = "Grouptype",
            GroupCode = "GroupCode",
            GroupName = "GroupName",
            QtyOnHand = "QtyOnHand",
            StockCostValue = "StockCostValue"
        }
    }
}
